import { render, staticRenderFns } from "./learneraccount.vue?vue&type=template&id=45a43f7e&scoped=true&"
import script from "./learneraccount.vue?vue&type=script&lang=ts&"
export * from "./learneraccount.vue?vue&type=script&lang=ts&"
import style0 from "./learneraccount.vue?vue&type=style&index=0&id=45a43f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a43f7e",
  null
  
)

export default component.exports